// extracted by mini-css-extract-plugin
export default {"workPlace":"WorkPlace_workPlace__oEf7K","container":"WorkPlace_container__OFVvX"};